<template>
  <v-container id="login" fluid fill-height class="login-page">
    <v-row align="center" justify="center" class="fill-height ma-0">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <div class="login-shell">
          <div class="login-brand-panel">
            <div class="brand-logo" @click="home">
              <span class="brand-smpl">smpl</span>
              <span class="brand-sale">sale</span>
            </div>

            <div class="welcome-title">Welcome back</div>
            <div class="welcome-subtitle">
              Sign in to manage sales, customers, inventory, and reports.
            </div>

            <div class="feature-list">
              <div class="feature-row">
                <v-icon small color="white">mdi-chart-line</v-icon>
                Real-time sales dashboard
              </div>

              <div class="feature-row">
                <v-icon small color="white">mdi-package-variant</v-icon>
                Inventory and reorder tracking
              </div>

              <div class="feature-row">
                <v-icon small color="white">mdi-receipt-text</v-icon>
                Fast invoices and payments
              </div>
            </div>
          </div>

          <div class="login-form-panel">
            <router-view />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authService from "./store.js";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";

export default {
  name: "authentication",

  mixins: [RegisterStoreModule],

  created() {
    this.registerStoreModule("auth", authService);

    const loginToken = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}token`
    );

    if (loginToken) {
      this.$router.push({ path: "/" });
    }
  },

  methods: {
    home() {
      window.open("https://smplsale.com", "_self");
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(37, 99, 235, 0.12), transparent 35%),
    #f8fafc;
}

.login-shell {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 540px;
  border-radius: 28px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.12);
  border: 1px solid #e2e8f0;
}

.login-brand-panel {
  padding: 42px;
  background: linear-gradient(135deg, #0f172a, #1e40af);
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.brand-logo {
  cursor: pointer;
  font-size: 34px;
  line-height: 1;
  margin-bottom: 44px;
}

.brand-smpl {
  color: #50e3c2;
  font-weight: 400;
}

.brand-sale {
  color: #ffffff;
  font-weight: 900;
}

.welcome-title {
  font-size: 34px;
  font-weight: 800;
  line-height: 1.1;
}

.welcome-subtitle {
  font-size: 15px;
  color: #cbd5e1;
  margin-top: 12px;
  max-width: 340px;
}

.feature-list {
  margin-top: 34px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.feature-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #e2e8f0;
  font-size: 14px;
}

.login-form-panel {
  padding: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 960px) {
  .login-shell {
    grid-template-columns: 1fr;
  }

  .login-brand-panel {
    padding: 28px;
  }

  .welcome-title,
  .welcome-subtitle,
  .feature-list {
    display: none;
  }

  .brand-logo {
    margin-bottom: 0;
    text-align: center;
  }

  .login-form-panel {
    padding: 24px;
  }
}

@media (max-width: 600px) {
  .login-page {
    padding: 12px !important;
  }

  .login-shell {
    border-radius: 20px;
  }
}
</style>